import { BaseComponentOption } from '@/scripts/Components/Utilities/DataProviderBaseComponent';
import { CollectionImplementationData } from '@/scripts/models/videoCollections/implementations/core/BaseCollectionImplementation';
import { Model } from '@viddsee/server-api-client';

interface Methods {
  fetchData: () => Promise<number>;
}
interface Props {
  video: Model.Video.Info;
  videoCollectionImplementation: CollectionImplementationData;
}

export default BaseComponentOption.extend<void, Methods, void, Props>({
  props: {
    video: {
      type: Object,
      required: true,
    },
    videoCollectionImplementation: {
      type: CollectionImplementationData,
      required: true,
    },
  },

  methods: {
    fetchData(): Promise<number> {
      const { fetchers } = this.videoCollectionImplementation;
      if (!fetchers) { return Promise.resolve(-1); }

      return Promise.resolve(fetchers.videoIndex());
    },
  },
});
